import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
//pages
import Home from "./pages/Home";
import Info from "./pages/Info";
import Cart from "./pages/Cart";
//components
import Navbar from "./components/Navbar";
function App() {
	return (
		<Router>
			<Navbar />
			<Switch>
				<Route path='/' exact>
					<Home />
				</Route>
				<Route path='/cart'>
					<Cart />
				</Route>
				<Route path='/info:id'>
					<Info />
				</Route>
			</Switch>
		</Router>
	);
}

export default App;
